import React from 'react';
import PropTypes from 'prop-types';
import { Modal, FormControl, FormGroup, ControlLabel, Button } from 'react-bootstrap';
import InfiniteCalendar from 'react-infinite-calendar';
import csLocale from 'date-fns/locale/cs';
import moment from 'moment';

export default class DateModal extends React.Component {
  static propTypes = {
    onChange: PropTypes.func.isRequired,
    onHide: PropTypes.func,
    show: PropTypes.bool.isRequired,
    value: PropTypes.string
  }

  static defaultProps = {
    onHide: () => undefined,
    value: moment()
  }

  componentWillMount() {
    const { value } = this.props;

    this.setState({ time: value || moment() });
  }

  setDate(dateValue) {
    const { time } = this.state;
    const newDate = moment(dateValue);

    if (newDate.isValid()) {
      time.set({
        year: newDate.year(),
        month: newDate.month(),
        date: newDate.date()
      });

      this.setState({ time });
    }
  }

  setTime({ target: { value: timeValue } }) {
    const { time } = this.state;
    const newTime = moment(timeValue, ['H:mm', 'H.mm', 'Hmm']);

    if (newTime.isValid()) {
      time.set({
        hour: newTime.hours(),
        minute: newTime.minutes(),
        second: 0
      });

      this.setState({ time });
    }
  }

  handleSubmit() {
    const { onChange } = this.props;
    const { time } = this.state;

    if (time.isValid()) { onChange(time); }
  }

  render() {
    const locale = {
      weekStartsOn: 1,
      weekdays: ['Ne', 'Po', 'Út', 'St', 'Čt', 'Pá', 'So'],
      todayLabel: {
        long: 'Dnes',
        short: 'Dnes',
      },
      locale: csLocale
    };
    const { time } = this.state;

    return (
      <Modal
        id="popover-1"
        show={this.props.show}
        onHide={this.props.onHide.bind(this)}
      >
        <Modal.Header closeButton>
          <Modal.Title>Vyberte datum</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <InfiniteCalendar
            min={new Date()}
            minDate={new Date()}
            locale={locale}
            disabledDays={[6, 7]}
            displayOptions={{ showHeader: false }}
            width="100%"
            height={300}
            onSelect={this.setDate.bind(this)}
            selected={time}
          />
          <div style={{ margin: 5 }}>
            <FormGroup>
              <ControlLabel>Čas: </ControlLabel>
              <FormControl
                defaultValue={time && time.format('H:mm')}
                onChange={this.setTime.bind(this)}
              />
            </FormGroup>
          </div>
          <Button
            onClick={this.handleSubmit.bind(this)}
            block
            bsStyle="primary"
          >
            Vybrat
          </Button>
        </Modal.Body>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/browser/Feature/components/date_modal.jsx